<template>
	<ul :class="['formulario',{'mode-editor': config.editor}]" v-if="estructura && estructura.length">

        <!-- Editor add-row -->
        <Editor :ficha="ficha" type="add-data" />

        <li 
        v-for="(data, d) in estructura"
        :key="d"
        :class="[
            estructura[d].some(e => e && ['editable','readonly','read-only'].includes(e.state) && e.visible) ? 'visible' : 'no-visible',
            {hidden: data.every(s => !s.visible)}
        ]">
            
            <el-row :gutter="5">

                <!-- Varios inputs en linea -->
                <template v-if="(data.length > 1) && data.every(e => e.title == data[0].title)">
                    <el-col :span="24">
                        <div :ref="`formgroup_${d}`" class="form-group form-group-merge" >
                            <el-row style="flex-grow: 1">
                                <el-col  
                                v-for="(input,i) in data"
                                :key="i"
                                :span="input.attr.hasOwnProperty('col') ? input.attr.col : 24"
                                :style="{'height': input.format == 'textarea' ? 'fit-content' : 'auto'}">
                                    
                                    <div class="form-group" v-loading="input.loading">
                                        <label :style="{'visibility': i !== 0 ? 'hidden' : 'visible'}">{{data[0].title}}</label>
                                        <div class="form-input">
                                            <InputSigarus
                                                :busy.sync="input.loading"
                                                v-show="input.visible"
                                                :identificador="id"
                                                :entidad="entidad"
                                                :siblings="inputList"
                                                ref="input"
                                                :input="input"
                                                :saveUrl="autosave ? `${apiUrl.backend}input` : ''"
                                                :type="input.format.includes('numeric') ? 'number' : input.format"
                                                :obligatorio="!!input.obligatorio"
                                                :value="formatValue(input)"
                                                :placeholder="input.placeholder"
                                                :readonly="(isExtraType(input) && ['id'].includes(isExtraType(input)) ? true : input.state == 'read-only') || (input.state == 'read-only')"
                                                :textPre="input.textpre"
                                                :textPos="input.textpos"
                                                :options="input.options"
                                                @input="val => emitInput(val, input)"
                                                @id="input => $emit('setActionId', input)"
                                                @go="inputGo"
                                                @saved="val => $emit('saved', val)"
                                                @focus="foc(`formgroup_${d}`, ['form-group form-group-merge focused'])"
                                                @blur="blur(`formgroup_${d}`, ['form-group form-group-merge'])"
                                                @obligatorio="foc(`formgroup_${d}_${i}`, ['form-group focused obligatorio'])"
                                                :actions="actionsByInput(input)"
                                                :porlet="porlet"
                                                />

                                                <template v-if="!['text:id','hidden:id'].includes(input.format)">
                                                    <el-tooltip
                                                    v-for="action,a in actionsByInput(input)"
                                                    :key="a"
                                                    class="item" 
                                                    effect="dark" 
                                                    :content="action ? action.titulo : ''" 
                                                    placement="top">
                                                   
                                                        <el-button
                                                        v-if="action"
                                                        @click="porlet.events.clickAction(action)"
                                                        type="default" 
                                                        size="mini" 
                                                        :icon="action.icon"
                                                        />
                                                    </el-tooltip>
                                                </template>
                                        </div>
                                        
                                        <!-- EDITOR -->
                                        <Editor :params="input" :ficha="ficha" type="data"/>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                </template>

                <!-- Input individual -->
                <template v-else>

                    <el-col  
                    v-for="(input,i) in data"
                    :key="i"
                    :span="input.attr.hasOwnProperty('col') ? input.attr.col : 24"
                    :style="{'height': input.format == 'textarea' ? 'fit-content' : 'auto'}">
                        
                        <div :ref="`formgroup_${d}_${i}`" class="form-group" v-loading="input.loading">
                            <label>{{data[i].title}}</label>
                            <div class="form-input">
                                <InputSigarus
                                    :busy.sync="input.loading"
                                    v-show="input.hasOwnProperty('visible') && input.visible"
                                    :identificador="id"
                                    :entidad="entidad"
                                    :siblings="inputList"
                                    ref="input"
                                    :input="input"
                                    :saveUrl="autosave ? `${apiUrl.backend}input` : ''"
                                    :type="input.format.includes('numeric') ? 'number' : input.format" 
                                    :obligatorio="!!input.obligatorio"
                                    :value="formatValue(input)"
                                    :placeholder="input.placeholder"
                                    :readonly="(isExtraType(input) && ['id'].includes(isExtraType(input)) ? true : input.state == 'read-only') || (input.state == 'read-only')"
                                    :textPre="input.textpre"
                                    :textPos="input.textpos"
                                    :options="input.options"
                                    @input="val => emitInput(val, input)"
                                    @id="input => $emit('setActionId', input)"
                                    @go="inputGo"
                                    @saved="val => $emit('saved', val)"
                                    @obligatorio="foc(`formgroup_${d}_${i}`, ['form-group focused obligatorio'])"
                                    @focus="foc(`formgroup_${d}_${i}`, ['form-group focused'])"
                                    @blur="blur(`formgroup_${d}_${i}`, ['form-group'])"
                                    :actions="actionsByInput(input)"
                                    :porlet="porlet"
                                />

                                <template v-if="!['text:id','hidden:id'].includes(input.format)">
                                    <el-tooltip 
                                    v-for="action, a in actionsByInput(input)"
                                    :key="a"
                                    class="item" 
                                    effect="dark" 
                                    :content="action ? action.titulo : ''" 
                                    placement="top">
                                        <el-button
                                        v-if="action"
                                        @click="porlet.events.clickAction(action)"
                                        type="default" 
                                        size="mini" 
                                        :icon="action.icon"
                                        />
                                    </el-tooltip>
                                </template>
                                
                                <!-- EDITOR -->
                                <Editor :params="input" :ficha="ficha" type="data"/>
                            </div>
                        </div>
                    </el-col>
                </template>

            </el-row>
        </li>
    </ul>
</template>

<script>
    import InputSigarus from '@/components/inputs/InputSigarus.vue'

    import Editor from '@/components/Editor/Editor.vue'

    import { mapState } from 'vuex'
    import { getUrl } from '@/helpers/api'

    import moment from 'moment'

	export default {
        name: 'Formulario',
        components: {
            InputSigarus,
            Editor
        },
		props: {
            ficha: {
                type: Object,
                required: false,
                default: () => null
            },
            entidad: String,
            url: {
                type: Object,
                required: false,
                default: () => null
            },
            objects: {
                type: Array,
                required: false,
                default: () => null
            },
            id: [Number,String],
            autosave: {
                type: Boolean,
                required: false,
                default: () => true
            },
            divider: {
				type: Boolean,
				required: false,
				default: () => true
            },
            focus: {
				type: Boolean,
				required: false,
				default: () => false
            },
            inputList: Array,
            visibleLabel: {
                type: Boolean,
                required: false,
                default: () => true
            },
            porlet: {
                type: Object
            }
        },
		data () {
            return {
                moment,
                apiUrl: '',
                estructura: null,
                currentAction: null,
                fichaInicial: null,
                formularioInicial: null,
                loading: false,
                inputsTypeGoId: ['id','go','botongo','botonid']
            }
        },
        computed: {
            ...mapState({
                config: state => state.config.data
            })
        },
        watch: {
            objects: {
                handler() {
                    this.init()
                },
                deep: true
            },
            estructura() {
                this.$nextTick(() => {
                    if (this.$refs.input) {
                        this.$emit('refsInputs', this.$refs.input.filter(input => !['hidden:id'].includes(input.type) && !input.readonly && !input.visible ))
                    }
                })
            }
        },
        mounted() {
            this.init()
            this.$emit('created')
        },
        methods: {
            foc(key, style) {
                this.$refs[key][0].classList.value = style
            },
            blur(key, style) {
                this.$refs[key][0].classList.value = style
            },
            init () {
                
                this.apiUrl = getUrl()

                // Si hay url realizamos peticion de lo contrario creamos estructura con los objetos que puedan llegar
                if (this.url) {

                    this.loading = true

                    try {

                        // Hacer merge de peticiones, la de por defecto y la final con lo que hay que pintar definitivamente
                        // ## FALTA POR METER PETICION A URL EXTERNA PARA OBTENER FORMULARIO
                        this.fichaInicial = form
                        this.formularioInicial = Object.keys(form.data).map(key => {
                            const el = form.data[key]
                            return (typeof el == 'object') ? el : ''
                        }).filter(el => el !== '')

                    } catch (e) {
                        //console.log('Error init :: ',e)
                    }

                    this.loading = false

                } else if (this.objects) {
                    
                    this.fichaInicial = this.ficha
                    this.formularioInicial = this.objects
                }

                this.crearEstructura()

                let _self = this
                setTimeout(() => {
                    //_self.createInputList() // Crea un listado de los input del formulario

                    if (_self.focus && _self.inputList && _self.inputList.length) { // primer elemento del formulario editable
                        _self.inputList[0].editing = true
                    }
                },100)

            },

            crearEstructura() {

                const salida = []
				let controlKey = 0
                
				this.formularioInicial.forEach((object_base, i) => {

                    const object = {...object_base}
                    object.loading = false

					if(controlKey == 0 || ( controlKey < i )) { 

						const array = []

						if(!object.attr.hasOwnProperty('divider') || ( object.attr.hasOwnProperty('divider') && object.attr.divider)) {
							array.push(this.formularioInicial[controlKey > 0 ? controlKey + 1 : ( controlKey == 0 ? controlKey + i : (i + 1) )]) // Hay divider, termina la fila
							controlKey = 0
						} else {

							let totalCol = 0 //Acumula el ancho de cada columna por fila recorrida
                            
							while(totalCol < 24) { // Comprueba si hay hueco para meter mas campos

								controlKey = controlKey > 0 ? controlKey + 1 : ( controlKey == 0 ? controlKey + (((totalCol>0 && totalCol<24) && i==0 )?i+1 : i) : (i + 1) ) // Almaceno el siguiente indice a recorrer

                                if(this.formularioInicial[controlKey]) {

                                        const currentCol = (this.formularioInicial[controlKey].attr.col || 24)
                                        if((totalCol + currentCol) <= 24) { // Comprobar limite de columnas para cada fila
                                            
                                            array.push(this.formularioInicial[controlKey])
                                            totalCol = totalCol + currentCol

                                            //TEST
                                            if(this.formularioInicial[controlKey].attr.divider == true) {
                                                totalCol = 24
                                            }
                                            
                                        } else {

                                            totalCol = 24
                                            controlKey = controlKey - 1

                                        }
                                    
                                    
                                } else {
                                    totalCol = 24
                                }
								
							}
						}

						salida.push(array)

					} else if (controlKey == i) {
						controlKey = 0
					}
				})

                this.estructura = salida
                
            },
            
            getUnionTitle(estructura) {
                // Para campos que esten en la misma fila y deban concatenar los titulos
                let out = estructura.reduce((acum, val) => {
                    if(!acum.includes(val.title)) acum.push(val.title)
                    return acum
                },[])

                return out.join(' / ')
            },

            // Comprobar si es de tipo id o go
            isExtraType (input) {

				const types = input.format.split(':')

				if (types.length < 2) return false

				return types[1]

			},

            inputGo(input) {

                if(!input.value) return

                this.$emit('openWindow', {
					entidad: input.entidad, 
					id: input.value
				})
            },

            filter_search(data) {
                
                let obj = false

                if (data[0].title) {
                    
                    let key = `${data[0].key}_filter`
                    let obj_filter = this.objects.find(f => f.key == key)
                    if (obj_filter) {
                        obj = {
                            options: obj_filter.options,
                            value: obj_filter.options[0].value,
                            key
                        }
                    }
                }
                
                return obj
            },

            actionsByInput (input) {

                let items = []
                let _self = this
                if (input && input.actions && input.actions.length && _self.fichaInicial.actions) {
                    items = Object.values(input.actions)
                    .filter(action => action != "")
                    .map(accion => {
                        let m = _self.fichaInicial.actions[accion]
                        if (!m) return

                        return {
                            icon: m.icon,
                            titulo: m.titulo,
                            auto: m.auto || true,
                            function: m.function || null,
                            metodo: m.metodo || null,
                            url: m.url ? m.url.replace('@@id@@',_self.id) : null
                        }
                    })
                }
                return items

            },

            // Formatear value
            formatValue(input) {

                let val = input.value

                if (input.format == 'datepicker') {

                    if (['0000-00-00',null,'',undefined].includes(val)) {
                        val = ''
                    } else {
                        val = moment(val,'YYYY-MM-DD').format('DD/MM/yyyy')
                    }

                } else if (input.format == 'datetimepicker') {

                    if (['0000-00-00',null,'',undefined].includes(val)) {
                        val = ''
                    } else {
                        val = moment(val,'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')
                    }
                }

                return val
            },
            emitInput(val, input) {
                
                let newvalue = val

                if(input.format == 'datepicker') {

                    newvalue = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD')

                } else if(input.format == 'datetimepicker') {

                    newvalue = moment(val, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
                }

                this.$emit('input', {newvalue, input})
            }
        }
	}
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';

form {
    width: 100%;
}

ul.formulario {
    padding: 0px;
    margin: 0.5rem 0rem;
    list-style: none;
    background-color: white;
    border: 1px solid #e5e5e5;
    overflow: hidden;
    border-radius: 6px;
    &.mode-editor {
        .form-group {
            position: relative;
            height: 51.78px;
        }
    }
    li {
        padding: 0rem 0.5rem 0.3rem 0.5rem;
        flex-flow: row;
        &.no-visible,
        &.hidden  {
            display: none!important;
        }
        &.visible {
            display: flex;
        }
        > div {
            flex-grow: 1;
        }
        .form-group {
            border: 1px solid #EBEEF5;
            border-radius: 6px;
            display: flex;
            flex-flow: column;
            overflow: hidden;
            &:hover {
                border: 1px solid #DCDFE6;
                .form-input form .holder > div:last-child .buttons {
                    display: flex;
                }
                .form-input .buttons button {
                    display: flex;
                }
            }
            &.focused {
                background-color: #ecf5ff!important;
                border: 1px solid $--color-primary!important;
                label {
                    top: 0px;
                }
                &.obligatorio {
                    background-color: #fde2e2!important;
                    border: 1px solid #F56C6C !important;
                }
            }
            &.form-group-merge {
                flex-flow: row;
                .form-group {
                    border: 0px;
                }
                .holder {
                    position: unset!important;
                }
            }
            label {
                flex-grow: 1;
                padding: 0.4rem 0.5rem 0rem;
                font-size: 0.85rem;
                color: #909090;
                height: 19px;
                overflow: hidden;
            }
            .form-input {
                flex-grow: 1;
                display: flex;
                .el-col {
                    &.height-fit {
                        height: fit-content!important;
                    }
                }
                form {
                    &:hover {
                        background-color: transparent;
                    }
                    &.editable {
                        .holder .label {
                            color: $--color-primary;
                        }
                    }
                    .holder {
                        position: relative;
                        .label {
                            margin-bottom: 0.4rem;
                            line-height: 20px;
                            color: #002b56;
                            font-weight: 600;
                            .truncate.placeholder {
                                height: 20px!important;
                            }
                            textarea {
                                font-weight: 600;
                            }
                        }
                         input {
                            border: 0px!important;
                            border-color: transparent;
                            background-color: transparent;
                            margin-bottom: 0.4rem;
                            height: 20px;
                            line-height: 20px;
                        }
                        textarea {
                            border-color: transparent;
                            background-color: transparent;
                        }
                        > div:last-child {
                            //position: relative;
                            .buttons {
                                display: flex;
                                position: absolute;
                                right: 0;
                                bottom: 0;
                                display: none;
                                background-color: white;
                                border-radius: 6px;
                                border: 0px;
                            }
                        }
                    }
                    .buttons {
                        button {
                            display: none;
                            margin: 1px 1px;
                            border-radius: 5px;
                            padding: 7px 9px;
                            max-height: 24px;
                            max-width: 30px;
                            border: 0px;
                        }
                    }
                }
            }
        }
    }
}

.placeholder {
    color: rgb(187, 187, 187);
}
</style>